import { Component } from 'react'
import { Col, Row } from 'reactstrap'
import TableColumnPreferenceControl from '../Material/TableColumnPreferenceControl'

class SubrogationClaimActions extends Component {
    constructor(props) {
        super(props)
        this.state = {
            openModal: "",
        }
    }

    toggleModal = (modalName) => {
        this.setState({ openModal: this.state.openModal === modalName ? "" : modalName })
    }

    render() {
        return (
            <Row>
                <Col xs={12} className="text-right mt-3">
                    <TableColumnPreferenceControl
                        tableId={this.props.tableId}
                        columnConfig={this.props.columnConfig}
                        setColumnConfig={this.props.setColumnConfig}
                        defaultColumnConfig={this.props.defaultColumnConfig}
                    />
                </Col>
            </Row>
        )
    }
}

export default (SubrogationClaimActions)
